export default {
  consumerKey: "ck_cacbf62f85eae3f2a43d07446e4a85bd71992b5d",
  consumerSecret: "cs_73547bca258bc6003624f1d5e81c18c8f6a02c8b"
};
